<template>
  <div class="record-day">
    <div v-if="!$route.query.operatorId" class="operate">
      <van-button size="small" :to="{ name: 'RecordCount', query: { date: $route.query.date } }">当日统计</van-button>
    </div>
    <div class="record-day-panel">
      <template v-if="list.length">
        <div class="count">{{ `共${totalCount}条` }}</div>
        <div class="list-item">
          <TrackItem v-for="item in list" :key="item.id" :data="item" />
        </div>
      </template>
      <van-empty v-else description="暂无数据" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import TrackItem from '../components/item'
import { trackList } from '@/api/track'
export default {
  name: 'RecordDay',
  components: { TrackItem },
  data() {
    return {
      totalCount: 0,
      list: []
    }
  },
  computed: {
    time() {
      const { date } = this.$route.query
      return {
        startTime: dayjs(date).startOf('day').unix(),
        endTime: dayjs(date).endOf('day').unix(),
        date: dayjs(date).format('M月DD日')
      }
    }
  },
  created() {
    const { date } = this.time
    if (date) {
      const { operatorName } = this.$route.query
      const title = operatorName ? `${operatorName}(${date})` : date;
      document.title = title
    }
    this.getTrackList()
  },
  methods: {
    getTrackList() {
      // 获取跟进记录列表
      const { startTime, endTime } = this.time
      const { operatorId } = this.$route.query
      const params = {
        page: 1,
        count: 1000,
        startTime,
        endTime,
        operatorId: operatorId ? Number(operatorId) : undefined
      };
      trackList(params).then(res => {
        if (res.errcode === 0) {
          this.list = res.data
          this.totalCount = res.page.totalCount
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .record-day {
    .operate { text-align: center; padding: 10px 0;
      .van-button { background-color: transparent; border: none; color: #02A7F0; height: 100%; font-size: 14px; }
    }
    &-panel {
      .count { padding: 10px; font-size: 14px; }
    }
  }
</style>